var React = require('react');

function LineCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M747.029,319.675c-13.421-7.857-29.492-7.091-39.128,2.875s-9.828,26.447-1.512,39.671c-3.4,3.641-6.994,7.282-10.4,10.923-17.39-17.057-17.957-45.808-.945-63.436a43.954,43.954,0,0,1,62.326-1.191l.24.234C754.023,312.392,750.62,316.033,747.029,319.675Z","transform":"translate(-682.613 -296.144)","fill":"currentColor"}));
}

LineCircle.defaultProps = {"width":"75","height":"77","viewBox":"0 0 75 77"};

module.exports = LineCircle;

LineCircle.default = LineCircle;
